import { FeatureType, BillableItemIds } from '../lib/enums/billableItem';
import { BusinessRegion } from '../lib/enums/businessRegion';
import { CampaignObjective } from '../lib/enums/campaign';
import featureFlags from '../lib/featureFlags';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';
import { AutomationTriggerTypes } from '../lib/enums/automationTriggerTypes';

const storage = new VuexLocalStorage('_FEATURE_');

export const state = {
  subscriptionFeatures: storage.get('subscriptionFeatures')?.split(',')
};

export const getters = {
  /* Feature access */
  showGrowthCampaigns(_state, _getters, rootState, rootGetters): boolean {
    if (rootGetters['client/isInternationalClient']) return false;
    if (rootGetters['user/isInternalUser']) return true;
    return (
      process.env.ShowGrowthCampaigns === 'true' &&
      rootState.client.businessRegion === BusinessRegion.UnitedStatesCanada
    );
  },

  showCampaignObjectiveSelectionPage(
    _state,
    getters,
    _rootState,
    rootGetters
  ): boolean {
    return (
      featureFlags.showCampaignObjectiveSelectionPage ||
      rootGetters['user/isInternalUser']
    );
  },

  /* Permissions */

  hasSendSmsPermission(state): boolean {
    return state.subscriptionFeatures?.includes(FeatureType.Sms);
  },

  hasFeature: state => (feature: string) => {
    return state.subscriptionFeatures?.includes(feature);
  },
  hasPermissionToEditCampaignObjective: (state, getters) => (
    campaignObjective: CampaignObjective
  ): boolean => {
    // FIXME: check correct permission.
    return true;
  },

  canSendMms: (_state, getters, _rootState, rootGetters) => (
    campaignObjective: CampaignObjective
  ): boolean => {
    const isAutomatedCampaign =
      campaignObjective === CampaignObjective.Automation;

    return (
      (campaignObjective === CampaignObjective.SimpleSms ||
        isAutomatedCampaign) &&
      rootGetters['client/isUSCanadaClient']
    );
  }
};

export const mutations = {
  setSubscriptionFeatures(state, payload): void {
    storage.set(state, payload, 'subscriptionFeatures');
  }
};
